export default {"src":"/_next/static/media/shield.cc19215a.svg","height":24,"width":24};